import {
  animate,
  AnimationTriggerMetadata,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export interface AnimationParams {
  width: string;
  height: string;
}

export const hostVideoAnimation: AnimationTriggerMetadata = trigger(
  'hostVideo',
  [
    state(
      'full',
      style({ bottom: 0, right: 0, width: '100%', height: '100%' }),
    ),
    state(
      'minified',
      style({
        bottom: '{{bottom}}',
        right: '{{right}}',
        width: '{{width}}',
        height: '{{height}}',
      }),
      {
        params: {
          width: '19.3rem',
          height: '14.4rem',
          bottom: '1.875rem',
          right: '1.875rem',
        },
      },
    ),
    transition('full => minified', [animate('300ms')]),
    transition('minified => full', [animate('300ms')]),
  ],
);
